module.exports = flarum.core.compat['components/Separator'];